import { Row } from '../types';
import { createUID } from './createUID';

export function createRow(): Row {
  return {
    cells: [],
    height: null,
    id: createUID(),
  };
}
